import styles from './IconCarouselLayout.module.scss';

import React from 'react';
import Slider from 'react-slick';

import { Grid } from 'components/Grid/Grid';
import { useBreakpoints } from 'hooks/useBreakpoints';
import type { AppType } from 'services/cms/typesUtil';
import { IconCard } from '../IconCard/IconCard';
import { ICON_CAROUSEL_LAYOUT_TEST_ID } from './IconCarouselLayout.const';

type IconCarouselLayoutProps = AppType.Component<{
  items: AppType.Content[];
}>;

export const IconCarouselLayout: React.FC<IconCarouselLayoutProps> = ({ items }) => {
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;

  const config = {
    arrows: true,
    infinite: false,
    swipe: !isDesktopOrLarge,
    variableWidth: true,
    accessibility: true,
    dots: true,
    cssEase: 'ease',
    dotsClass: styles.paginationDots,
  };

  return (
    <Grid container justifyContent="flex-end" data-testid={ICON_CAROUSEL_LAYOUT_TEST_ID.layout}>
      <Grid
        item
        lg={10}
        md={9}
        xs={12}
        className={styles.gridStyle}
        data-testid={ICON_CAROUSEL_LAYOUT_TEST_ID.slider}
      >
        <Slider {...config} className={styles.cardSlider}>
          {items?.map(item => (
            <IconCard item={item} key={item?._sys?.id} />
          ))}
        </Slider>
      </Grid>
    </Grid>
  );
};
